import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SyncDiffPage } from '@features/admin/sync-diff';
import { useAdminSyncDiffStore } from '@features/admin/sync-diff/useAdminSyncDiffStore.ts';

/** Výběr dlaždice v souhrnu — filtruje tabulku pod ním. URL je jediný zdroj pravdy. */
export const syncDiffViews = ['SOURCE', 'DB', 'MATCHED', 'MISSING_IN_DB', 'EXTRA_IN_DB'] as const;

const adminSyncDiffSearchSchema = z.object({
  orgSourceId: z.coerce.number().optional(),
  sourceType: z.enum(['NP', 'ORG']).optional().default('NP'),
  view: z.enum(syncDiffViews).optional(),
});

export type AdminSyncDiffSearch = z.infer<typeof adminSyncDiffSearchSchema>;

export const Route = createFileRoute('/admin/sync-diff/')({
  validateSearch: search => adminSyncDiffSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { orgSourceId, sourceType } = ctx.search;
    if (orgSourceId != null) {
      useAdminSyncDiffStore.getState().loadSyncDiff(orgSourceId, sourceType);
    } else {
      useAdminSyncDiffStore.getState().reset();
    }
  },
});

function RouteComponent() {
  return <SyncDiffPage />;
}
